import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

function MBAGraduationDay202325() {

    const images = [
        "1000361278.jpg",
        "1000361290.jpg",
        "1000361314.jpg",
        "1000361317.jpg"
    ];

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">

                                    <h2 className="pb-2">
                                        MBA Graduation Day – Batch of 2023–25
                                    </h2>

                                    <p>
                                        A momentous <strong>MBA Graduation Ceremony</strong> was held at 
                                        <strong> Sridevi Women's Engineering College</strong> on 
                                        <strong> 1st November 2025</strong> to honor the graduating 
                                        <strong> 2023–25 MBA batch</strong>. The event began with a warm welcome by the student hosts, 
                                        followed by the ceremonial lighting of the lamp by the esteemed dignitaries.
                                        <br /><br />

                                        <strong>Dignitaries Present:</strong><br />
                                        • Principal – <strong>Dr. A. Narmada</strong><br />
                                        • Controller of Examinations – <strong>Mr. K. Tulsiram</strong><br />
                                        • Dean Alumni – <strong>Dr. K. C. Ravikumar</strong><br />
                                        • Dean IIC & Outreach – <strong>Dr. B. Narendra Kumar</strong><br />
                                        • MBA HOD – <strong>Dr. U. Padmavati</strong><br />
                                        • Additional Controller of Examinations – <strong>Mr. K. Pradeep</strong><br />
                                        • Additional Controller of Examinations – <strong>Dr. S. Suman</strong>
                                        <br /><br />

                                        The Principal, <strong>Dr. A. Narmada</strong>, delivered an inspiring address, 
                                        followed by remarks from <strong>Dr. B. Narendra Kumar</strong>, Dean IIC and Outreach.
                                        <br /><br />

                                        One of the most significant moments of the ceremony was the <strong>MBA Pledge</strong>. 
                                        Graduates stood with raised right hands, responding <em>“I do promise”</em> as they 
                                        committed themselves to the responsibilities and values of their profession. 
                                        The Principal then formally declared the Graduation Day open.
                                        <br /><br />

                                        <strong>Academic Gold Medals</strong> for MBA HR and MBA Finance toppers were 
                                        presented by the Principal, followed by the distribution of MBA Degree Certificates 
                                        by all dignitaries.
                                        <br /><br />

                                        The ceremony reached its emotional peak during the <strong>Hat Change Ceremony</strong>. 
                                        On the Principal’s announcement, graduates turned their hats from right to left, 
                                        symbolizing their transition into postgraduates.
                                        <br /><br />

                                        The event concluded with the <strong>Vote of Thanks</strong> delivered by 
                                        <strong> Dr. K. Sri Rangalakshmi</strong>, expressing gratitude to the Management, 
                                        Principal, Deans, HODs, faculty, and the organizing team. The ceremony ended with the 
                                        <strong>National Anthem</strong>, followed by group photo sessions and alumni interactions.
                                    </p>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {images.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/mba-graduation-day/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/mba-graduation-day/${img}`}
                                                            loading="lazy"
                                                            alt={`MBA Graduation Day – Batch of 2023–25 Image ${index + 1}`}
                                                            className="img-responsive center-block rounded-1 sixteen-nine"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default MBAGraduationDay202325;
